import { Component, EventEmitter, Input, Output } from '@angular/core';

import { KeyPersonnelFormKey } from '../../../../../shared/utils/types';
import { KEY_PERSONNEL_DETAILS_FORM_KEYS } from '../../../../../shared/utils/constants';
import { CommonForm } from "../common-form/common-form";
import { Header } from '../../../../../core/services/header';

@Component({
  selector: 'app-authorized-signatory',
  imports: [CommonForm],
  templateUrl: './authorized-signatory.html',
  styleUrl: './authorized-signatory.css'
})
export class AuthorizedSignatory {
  @Input() data: any;
  @Output() closeCurrentForm = new EventEmitter<any>();

  activeForm: KeyPersonnelFormKey = KEY_PERSONNEL_DETAILS_FORM_KEYS.AUTHORIZED_SIGNATORY;

  constructor(private headerService: Header) {

  }

  ngOnInit(): void {
    //Set header configs
    this.headerService.updateConfig({
      title: 'Authorized signatory',
      showNotifications: false,
      showRightSection: false,
      dropdownOptions: []
    });
  }

  ngOnDestroy(): void {
    this.headerService.resetConfig();
  }

  handleFormSubmission(formData: any) {
    console.log("Received form data:", formData);

    //todo handle api calls
    this.closeCurrentForm.emit();
  }



}
